import { chatAuthHeaders, getResolvedApiSuiteBase } from "@/apiBase";
import { readStoredSuiteUserId } from "@/suiteSession";

export type ChatSuiteResult<T> = {
  ok: boolean;
  status: number;
  data: T;
};

export function chatSuiteApiUrl(path: string): string | null {
  const base = getResolvedApiSuiteBase();
  if (!base) return null;
  return `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}

export async function chatSuiteFetch<T = Record<string, unknown>>(
  path: string,
  init: RequestInit = {}
): Promise<ChatSuiteResult<T>> {
  const url = chatSuiteApiUrl(path);
  if (!url) {
    return { ok: false, status: 0, data: { message: "API Suite introuvable." } as T };
  }
  const uid = readStoredSuiteUserId();
  try {
    const res = await fetch(url, {
      credentials: "include",
      cache: "no-store",
      ...init,
      headers: {
        ...chatAuthHeaders(uid),
        ...(init.headers as Record<string, string> | undefined),
      },
    });
    const data = (await res.json().catch(() => ({}))) as T;
    return {
      ok: res.ok && (data as { success?: boolean }).success !== false,
      status: res.status,
      data,
    };
  } catch {
    return { ok: false, status: 0, data: { message: "Réseau indisponible." } as T };
  }
}
